
import "../App.css";
import DashboardHome from "./DashboardHome";
import { useEffect, useState } from "react";
import { LuPanelLeftClose, LuPanelLeftOpen } from "react-icons/lu";
import { MdKeyboardArrowRight, MdKeyboardArrowDown } from "react-icons/md";
import { CiSearch } from "react-icons/ci";


import { useLocation, useNavigate } from "react-router-dom";
import ErrorCorrection from "./ErrorCorrection";
import WhatsNewBell from "../components/WhatsNewBell";
import AnnouncementTicker from "../components/AnnouncementTicker";
import { FaUserCircle } from "react-icons/fa";
import { FaChartLine } from "react-icons/fa";

import { FaLayerGroup, FaChartBar, FaCogs, FaUserTie, FaBullhorn } from "react-icons/fa";

const API = process.env.REACT_APP_NAV_API;

export default function Home() {
  const [user, setUser] = useState(null);
  const [tree, setTree] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [openFolders, setOpenFolders] = useState(() => new Set());

  const [view, setView] = useState("HOME"); // HOME | IFRAME
  const [selectedUrl, setSelectedUrl] = useState(null);
  const [selectedNodeId, setSelectedNodeId] = useState(null);
  const [selectedPath, setSelectedPath] = useState([]);
  // const [pendingByNodeId, setPendingByNodeId] = useState({});
  const [imgError, setImgError] = useState(false);
  const [savedOpenFolders, setSavedOpenFolders] = useState(new Set());

const activeDoerEmail = user?.email || "";
const location = useLocation();
const navigate = useNavigate();


const [search, setSearch] = useState("");
const [searchResults, setSearchResults] = useState([]);
const [showSearch, setShowSearch] = useState(false);
const isErrorCorrectionPage = location.pathname === "/error-correction";
const errorCorrectionMode =
  new URLSearchParams(location.search).get("mode") || "pc";

async function loadTree() {
  setLoading(true);
  setErr("");

  try {
    const r = await fetch(`${API}/nav/tree`, {
      credentials: "include"
    });

    const txt = await r.text();
    if (!r.ok) throw new Error(`HTTP ${r.status}: ${txt.slice(0, 200)}`);

    const data = JSON.parse(txt);

// 🔥 FIXED
const finalTree = Array.isArray(data?.items) ? data.items : [];

setTree(finalTree);

// open root folders
const rootIds = finalTree.map((n) => n.node_id);
setOpenFolders(new Set(rootIds));

  } catch (e) {
    setErr(String(e?.message || e));
  } finally {
    setLoading(false);
  }
}



  // initial load
useEffect(() => {
  if (user) {
    loadTree();
  }
}, [user]);

  // listen refresh event (from /admin)
  useEffect(() => {
    const handler = () => loadTree();
    window.addEventListener("NAV_REFRESH", handler);
    return () => window.removeEventListener("NAV_REFRESH", handler);
  }, []);

function flattenTree(nodes, parentPath = [], parentIds = []) {
  let res = [];

  for (let n of nodes) {
    const path = [...parentPath, n.node_name];
    const ids = [...parentIds, n.node_id];

    res.push({
      ...n,
      path,
      parentIds   // ✅ IMPORTANT
    });

    if (n.children) {
      res = res.concat(flattenTree(n.children, path, ids));
    }
  }

  return res;
}
function onHome() {
  navigate("/");          // ✅ important
  setView("HOME");
  setSelectedUrl(null);
}

function onClickLink(url, nodeId, pathNames, parentIds = []) {
  setSelectedNodeId(nodeId);
  setSelectedPath(pathNames);

  // 🔥 Google Forms
  if (url && url.includes("docs.google.com/forms")) {
    window.open(url, "_blank");
    return;
  }

  // 🔥 Google Drive
  if (
    url &&
    (
      url.includes("drive.google.com") ||
      url.includes("docs.google.com/spreadsheets") ||
      url.includes("docs.google.com/document") ||
      url.includes("docs.google.com/presentation")
    )
  ) {
    window.open(url, "_blank");
    return;
  }

  // 🔥 Cloud Run services (all Standard_Generic_Structure deployments) —
  // these require their own Google login, which fails inside an
  // iframe (403), so they must open in a new tab instead.
  if (url && url.includes(".run.app")) {
    window.open(url, "_blank");
    return;
  }

  // 🔥 Cloud Run services (all Standard_Generic_Structure deployments) —
  // these require their own Google login, which fails inside an
  // iframe (403), so they must open in a new tab instead.
  if (url && url.includes(".run.app")) {
    window.open(url, "_blank");
    return;
  }

  // ✅ internal app route
  if (url && url.startsWith("/error-correction")) {
    setSelectedUrl(null);
    setView("HOME");
    navigate(url);
  } 
  else if (url && url.startsWith("/sales-dashboard")) {
    setSelectedUrl(url);
    setView("IFRAME");
    navigate("/");
  }
  else {
    setSelectedUrl(url);
    setView("IFRAME");

    const cleanPath = pathNames
      .map((p) => p.toLowerCase().replace(/\s+/g, "-"))
      .join("/");

    navigate(`/${cleanPath}`);
  }

  // auto open folders
  setOpenFolders((prev) => {
    const next = new Set(prev);
    parentIds.forEach((id) => next.add(id));
    return next;
  });
}

  function toggleFolder(nodeId) {
    setOpenFolders((prev) => {
      const next = new Set(prev);
      if (next.has(nodeId)) next.delete(nodeId);
      else next.add(nodeId);
      return next;
    });
  }
  // ✅ Allow other components (PendingTaskCards) to open a folder in sidebar
useEffect(() => {
  window.openSidebarFolders = function (folderIds = []) {
    setOpenFolders((prev) => {
      const next = new Set(prev);
      folderIds.filter(Boolean).forEach((id) => next.add(id));
      return next;
    });
    setSidebarOpen(true);
  };

  return () => delete window.openSidebarFolders;
}, []);


// useEffect(() => {
//    if (!user?.email) return;

//   async function loadPendingBadges() {
//     try {
//       // const res = await fetch(
//       //   `${API}/pending/summary?doerEmail=${encodeURIComponent(activeDoerEmail)}`
//       // );
//       const res = await fetch(`${API}/pending/summary`, {
//         credentials: "include"
//       });
//       const json = await res.json();
//       if (!res.ok || !json.ok) return;

//       const byProcess = json?.data?.byProcess || {};
//       const map = {};

//       Object.values(byProcess).forEach((arr) => {
//         (arr || []).forEach((p) => {
//           if (p?.node_id && Number(p.pending) > 0) {
//             map[p.node_id] = Number(p.pending);
//           }
//         });
//       });

//       setPendingByNodeId(map);
//     } catch (e) {
//       setPendingByNodeId({});
//     }
//   }

//   loadPendingBadges();
// }, [API, activeDoerEmail]);


useEffect(() => {
  async function loadUser() {
    try {
      const res = await fetch(`${API}/auth/me`, {
  credentials: "include"
});

      const data = await res.json();

      if (data?.user) {
        setUser(data.user);
      }
    } catch (e) {
      console.error("User fetch failed", e);
    }
  }

  loadUser();
}, []);

useEffect(() => {
  if (!tree.length) return;

  const pathArray = location.pathname
    .split("/")
    .filter(Boolean)
    .map(p => p.replace(/-/g, " ").toLowerCase());

  if (!pathArray.length) return;

  function findNodeByPath(nodes, pathArr, parents = [], parentNames = []) {
    for (let n of nodes) {
      if (n.node_name.toLowerCase() === pathArr[0]) {
        if (pathArr.length === 1) {
          return {
            node: n,
            parents,
            parentNames
          };
        }

        if (n.children) {
          return findNodeByPath(
            n.children,
            pathArr.slice(1),
            [...parents, n.node_id],
            [...parentNames, n.node_name]
          );
        }
      }
    }
    return null;
  }

  const found = findNodeByPath(tree, pathArray);

  if (found && found.node?.embed_url) {
    onClickLink(
      found.node.embed_url,
      found.node.node_id,
      [...found.parentNames, found.node.node_name],
      found.parents
    );
  }

}, [tree, location.pathname]);

useEffect(() => {
  if (!search.trim()) {
    setSearchResults([]);
    return;
  }

  const flat = flattenTree(tree);
  // console.log("FLAT:", flat);

const q = search.trim().toLowerCase();
// console.log("SEARCH:", q);   // ✅ ADD HERE

const filtered = flat.filter((n) => {
  const name = n.node_name?.toLowerCase() || "";
  const path = (n.path || []).join(" ").toLowerCase();
  const url = (n.embed_url || "").toLowerCase();

  return (
    (name.includes(q) || path.includes(q)) &&
    n.node_type === "LINK" &&
    (url.startsWith("http") || url.startsWith("/"))  // 🔥 ONLY VALID LINKS
  );
});
// console.log("FILTERED:", filtered);
  setSearchResults(filtered.slice(0, 10)); // limit
}, [search, tree]);


useEffect(() => {
  // console.log("TREE:", tree);   // ✅ ADD HERE
}, [tree]);

useEffect(() => {
  function handleClickOutside() {
    setShowSearch(false);
  }

  window.addEventListener("click", handleClickOutside);
  return () => window.removeEventListener("click", handleClickOutside);
}, []);

const rolesArr = Array.isArray(user?.roles)
  ? user.roles
  : String(user?.roles || "").split(",");

const isSalesUser = rolesArr.some(r =>
  r.trim().toLowerCase() === "sales" ||
  r.trim().toLowerCase() === "admin"
);

  return (
<>
      {/* ✅ MOVE STYLE HERE */}
    <style>{`
      .mainHeaderNew {
        background: #f5f6f8;
        border-bottom: 1px solid #e0e0e0;
        display: flex;
        align-items: center;
        padding:12px 20px;
        justify-content: space-between;
      }

/* Wrap to position icon */
.headerSearchWrap {
  position: relative;
  display: flex;
  align-items: center;
}

/* 🔍 Icon inside input */
.searchIcon {
  position: absolute;
  left: 10px;
  color: #434242;
}

/* Input with padding for icon */
.headerSearchInput {
  width: 320px;
  padding: 5px 12px 5px 34px; /* 👈 left padding for icon */
  border-radius: 8px;
  border: 1px solid #c4c4c4;
  outline: none;
  background: #e1e4ea;
  font-size: 12px;
}

      .searchDropdown {
        position: absolute;
        top: 42px;
        left: 0;
        width: 400px;
        background: #fff;
        border: 1px solid #ddd;
        border-radius: 8px;
        max-height: 300px;
        overflow-y: auto;
        z-index: 999;
        box-shadow: 0 4px 10px rgba(0,0,0,0.08);
      }

      .searchItem {
        padding: 10px 12px;
        cursor: pointer;
        border-bottom: 1px solid #eee;
      }

      .searchItem:hover {
        background: #f5f6f8;
      }

      .searchTitle {
        font-size: 13px;
      }

      .searchPath {
        font-size: 11px;
        color: #777;
      }

      .searchEmpty {
        padding: 10px;
        font-size: 12px;
        color: #999;
      }

      .headerRight {
        display: flex;
        align-items: center;
        gap: 14px;
      }

      .headerWelcome {
        font-size: 14px;
        color: #666;
      }

      .headerWelcome span {
        font-weight: 600;
        color: #222;
      }

      .headerAvatar {
        width: 31px;
        height: 31px;
        border-radius: 50%;
        background: #3f6ad8;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        font-size: 14px;
        font-weight: 600;
        color: #fff;
      }

      .headerAvatarImg {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      /* LEFT GROUP */
.headerLeft {
  display: flex;
  align-items: center;
  gap: 12px;
}

.headerHomeBtn {
  background: #ffffff;
  border: 1px solid #d0d0d0;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #203a78;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.16);
}

/* Hover effect */
.headerHomeBtn:hover {
  background: #dde0e6;
  border-color: #bdbdbd;
}

/* Click (active) effect */
.headerHomeBtn:active {
  transform: scale(0.96);
  background: #e9ecef;
}
    `}</style>
    <div className="layout">
      <aside className={`sidebar ${sidebarOpen ? "open" : "closed"}`}>
<div className="sidebarTopNew">
  {sidebarOpen && (
    <button className="brandBlock" onClick={onHome} title="Home">
      <div className="brandLogoWrap">
        <img className="brandLogo" src="/logo.jpg" alt="Logo" />
      </div>
      <div className="brandName">GEPL Capital Pvt. Ltd.</div>
    </button>
  )}

  <button
    className="collapseBtn"
    title="Toggle Sidebar"
onClick={() => {
  setSidebarOpen((prev) => {
    if (prev) {
      // 👉 closing sidebar → save current state
      setSavedOpenFolders(new Set(openFolders));

      // 👉 collapse to ONLY root folders
      const rootIds = tree.map((n) => n.node_id);
      setOpenFolders(new Set(rootIds));

    } else {
      // 👉 opening sidebar → restore previous state
      setOpenFolders(new Set(savedOpenFolders));
    }

    return !prev;
  });
}}
  >
   {sidebarOpen ? (
  <LuPanelLeftClose size={18} />
) : (
  <LuPanelLeftOpen size={18} />
)}

  </button>
</div>



        <div className="navArea">
          {loading && <div className="muted">Loading menu…</div>}
          {err && <div className="error">⚠ {err}</div>}

           {!loading && !err && (
           <NavTree
             items={tree}
             sidebarOpen={sidebarOpen}
             openFolders={openFolders}
             onToggleFolder={toggleFolder}
             onClickLink={onClickLink}
             selectedNodeId={selectedNodeId}
            //  pendingByNodeId={pendingByNodeId}   // ✅ ADD
           />
           )}

        </div>

        {user && sidebarOpen && (
       <div className="sidebarUser">
         {!imgError && user.picture ? (
           <img
             src={user.picture}
             alt="profile"
             className="sidebarUserImg"
             onError={() => setImgError(true)}
           />
         ) : (
           <div className="sidebarUserFallback">
             <FaUserCircle size={22} />
           </div>
         )}
       
         <div className="sidebarUserInfo">
           <div className="sidebarUserName">{user.name}</div>
           <div className="sidebarUserEmail">{user.email}</div>
         </div>
       </div>
       )}
             </aside>
            
    <main className="main">
<div className="mainHeaderNew">

  {/* 🔥 LEFT SECTION (Home + Search) */}
  <div className="headerLeft">

    {/* ✅ Home Button */}
    <button className="headerHomeBtn" onClick={onHome}>
      Home
    </button>
    {/* ✅ Sales Button */}
{isSalesUser && (
  <button
    className="headerHomeBtn"
    onClick={() => {
      onClickLink(
        "/sales-dashboard",
        "sales-dashboard",
        ["Sales Dashboard"],
        []
      );
    }}
  >
    Sales
  </button>
)}

    {/* 🔍 Search */}
<div className="headerSearchWrap">

  {/* 🔍 ICON */}
  <CiSearch className="searchIcon" size={18} />

  <input
    type="text"
    placeholder="Search Process Name"
    value={search}
    onChange={(e) => {
      setSearch(e.target.value);
      setShowSearch(true);
    }}
    onFocus={() => setShowSearch(true)}
    onClick={(e) => e.stopPropagation()}
    className="headerSearchInput"
  />

  {/* Dropdown */}
  {showSearch && search.trim() && (
    <div
      className="searchDropdown"
      onClick={(e) => e.stopPropagation()}
    >
      {searchResults.length === 0 ? (
        <div className="searchEmpty">No results found</div>
      ) : (
        searchResults.map((item) => (
          <div
            key={item.node_id}
            className="searchItem"
            onClick={() => {
              onClickLink(item.embed_url, item.node_id, item.path, item.parentIds);
              setSearch("");
              setShowSearch(false);
            }}
          >
            <div className="searchTitle">{item.node_name}</div>
            <div className="searchPath">{item.path.join(" > ")}</div>
          </div>
        ))
      )}
    </div>
  )}
</div>
    

  </div>

  {/* 👉 RIGHT SIDE */}
  <div className="headerRight">

    <div className="headerWelcome">
      {user ? (
        <>
          Welcome, <span>{user.name}</span>
        </>
      ) : "Loading..."}
    </div>

    <WhatsNewBell 
      activeDoerEmail={user?.email} 
      activeDoerName={user?.name} 
    />

    <div className="headerAvatar">
      {user?.picture && !imgError ? (
        <img
          src={user.picture}
          alt="profile"
          className="headerAvatarImg"
          onError={() => setImgError(true)}
        />
      ) : (
        <span>
          {user?.name?.[0]?.toUpperCase() || "U"}
        </span>
      )}
    </div>

  </div>
</div>

     {view === "HOME" && <AnnouncementTicker />}

       <div className="content">
         {/* ✅ If route is /error-correction, show that page */}
{isErrorCorrectionPage ? (
  <ErrorCorrection
    activeDoerEmail={user?.email}
    mode={errorCorrectionMode}
  />
) : view === "HOME" ? (
  // <DashboardHome activeDoerEmail={user?.email} />
  <DashboardHome
  activeDoerEmail={user?.email}
  onNavigate={onClickLink}   // ✅ pass navigation function
/>
) : (
  <iframe key={selectedUrl} title="Dashboard" src={selectedUrl} className="iframe" />
)}
       
         
       </div>
    </main>
    </div>
</>
  );
}


const ROOT_ICONS = {
  "Common": <FaLayerGroup size={16} />,
  "MIS / Reports": <FaChartBar size={16} />,
  "Processes": <FaCogs size={16} />,
  "PC Tools": <FaUserTie size={16} />,
  "Sales": <FaBullhorn size={16} />,
   "EM Section": <FaChartLine size={16} />
};

function NavTree({
  items,
  sidebarOpen,
  openFolders,
  onToggleFolder,
  onClickLink,
  selectedNodeId,
  // pendingByNodeId = {},
  depth = 0,
  parentPath = [],
  parentPathIds = []   // ✅ ADD THIS
}){


  return (
    <div className="navList">
      {(items || [])
  // .filter((n) => {
  //   if (n.node_type === "LINK") return true;
  //   return (n.children || []).length > 0;
  // })
  .map((n) => {
        const isFolder = n.node_type === "FOLDER";
        const isLink = n.node_type === "LINK";
        const hasChildren = (n.children || []).length > 0;
        const open = isFolder && openFolders.has(n.node_id);
        // const pending = Number(pendingByNodeId?.[n.node_id] || 0);
        // const indent = isLink ? depth * 5 : depth * 12;
         const isActive = selectedNodeId === n.node_id;
         const isRoot = depth === 0;
const icon = isRoot
  ? (ROOT_ICONS[n.node_name] || <FaLayerGroup size={16} />)
  : sidebarOpen
    ? (open ? <MdKeyboardArrowDown size={18} /> : <MdKeyboardArrowRight size={18} />)
    : null;

        return (
          <div
             key={n.node_id}
             className={`navItem depth-${depth} ${isLink ? "isLink" : "isFolder"}`}
             
           >


            {isFolder && (
              <button className={`navRowNew ${open ? "open" : ""}`} style={{ "--indent": `${depth * 15}px` }} onClick={() => onToggleFolder(n.node_id)} title={n.node_name}>
                <span className="navLeft">
                  {icon && (
  <span className="navTypeIcon folderIcon">{icon}</span>
)}
                  {sidebarOpen && <span className="navTextNew">{n.node_name}</span>}
                </span>
                {/* {pending > 0 && sidebarOpen && (
                    <span style={{
                      marginLeft: "auto",
                      background: "#d32f2f",
                      color: "#fff",
                      fontSize: 11,
                      padding: "2px 6px",
                      borderRadius: 999
                    }}>
                      {pending}
                    </span>
                  )} */}
                                


              </button>

            )}

            {isLink && (
  <button
    className={`navRowNew navLinkRow ${isActive ? "active" : ""}`}
    onClick={() =>
      onClickLink(
  n.embed_url,
  n.node_id,
  [...parentPath, n.node_name],
  parentPathIds
)
    }
    title={n.node_name}
    style={{ "--indent": `${depth * 22}px` }}
  >
    <span className="navLeft">
      {sidebarOpen && <span className="navTextNew">{n.node_name}</span>}
    </span>

    {/* ✅ Pending badge */}
    {/* {sidebarOpen && pending > 0 && (
      <span
        style={{
          marginLeft: "auto",
          background: "#d32f2f",
          color: "#fff",
          fontSize: 12,
          fontWeight: 700,
          padding: "2px 8px",
          borderRadius: 999,
        }}
      >
        {pending}
      </span>
    )} */}
  </button>
)}

            {isFolder && hasChildren && open && (
<NavTree
  items={n.children}
  sidebarOpen={sidebarOpen}
  openFolders={openFolders}
  onToggleFolder={onToggleFolder}
  onClickLink={onClickLink}
  selectedNodeId={selectedNodeId}
  // pendingByNodeId={pendingByNodeId}   // ✅ ADD
  depth={depth + 1}
  parentPath={[...parentPath, n.node_name]}
parentPathIds={[...parentPathIds, n.node_id]}
/>
)}

          </div>
        );
      })}
    </div>
  );
}
